var render = function render(){var _vm=this,_c=_vm._self._c;return _c('planning-view',{attrs:{"root-page-full-path":_vm.rootPageFullPath,"ee-search-tokens":_vm.searchTokens}})
}
var staticRenderFns = []

export { render, staticRenderFns }